import { H1, Alert, P, rem, useLang, typography } from '@manulife/mux';
import { ButtonXIcon } from '@manulife/mux-cds-icons';
import Labels from "../../assets/labels";
import useWindowSize from '../../customHooks/useWindowSize';
import { colors } from '@manulife/mux';
import { useSelector } from 'react-redux';
import NumberConstants from "../../assets/appStyledComponents/numberConstant.json";

export default function RtgPageHeader() {
    const {num40, num15, num480} = NumberConstants;
    const selectedLang = useLang();
    const { width: windowWidth } = useWindowSize();
    const isError = useSelector(
        (state) => state.errorReducer?.isError
    );
    let customStyle = {
        elementStyle: {
            padding: `${rem(0)}`,
            fontWeight: typography.fontWeightLight
        },
    };
    if (windowWidth < num480) {
        customStyle = {
            elementStyle: {
                padding: `${rem(0)} ${rem(num15)}`,
                fontWeight: typography.fontWeightLight
            },
        }
    };
    let subTitleStyle = {
        elementStyle: {
            padding: `${rem(0)}`,
        },
    };
    if (windowWidth < num480) {
        subTitleStyle = {
            elementStyle: {
                padding: `${rem(0)} ${rem(num15)}`,
            },
        }
    };

    return (
        <>
            {isError && <Alert
                className={windowWidth < num480 ? "rtgErrorAlertXs" : "rtgErrorAlert"}
                variant={Alert.VARIANT.PRIMARY}
                severity={Alert.SEVERITY.ALERT}
                hasCloseButton
                closeIcon={<ButtonXIcon color={colors.dark_navy} fontSize={rem(num40)} />}
            >
                {Labels.errors.apiFailed[selectedLang]}
            </Alert>}
            <H1 role="heading" aria-level="1" customStyle={customStyle}>{Labels.title[selectedLang]}</H1>
            <P customStyle={subTitleStyle}>{Labels.subtitle[selectedLang]}</P>
        </>
    )
};